export class CatalogConstants {
    public static readonly CATALOG = 'catalog';
}